import React from 'react'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../../../common/integrations'
import { CrossClientQueryDataSource } from '../../../../models/CrossClient'
import styles from './CrossClientResultSourceIcon.module.scss'

type IconSize = 'sm' | 'md'

const sizeMap: Record<IconSize, string> = {
  sm: '0.75rem',
  md: '1rem',
}

interface CrossClientResultSourceIconProps {
  source: CrossClientQueryDataSource
  size?: IconSize
}

export const CrossClientResultSourceIcon: React.FC<CrossClientResultSourceIconProps> = ({ source, size = 'sm' }) => {
  const dimension = sizeMap[size]

  if (source.type === 'clientProfile') {
    return <i className={`bi bi-person-lines-fill ${styles[size]}`} />
  }

  if (source.type === 'meeting') {
    return <i className={`bi bi-calendar ${styles[size]}`} />
  }

  if (source.type === 'integration') {
    return <IntegrationIcon serviceId={source.integrationType as IntegrationServiceId} width={dimension} height={dimension} />
  }

  return <i className={`bi bi-question ${styles[size]}`} />
}
